var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"showtab-warp"},[_c('h3',[_vm._v("顶端tab栏")]),_vm._v(" "),_c('scroll-tab')],1)}
var staticRenderFns = []
export { render, staticRenderFns }